import React from 'react';

import msg from 'lib/msg';

export const PlainErrorMessage = () => (
  <div>
    <h1 className="error-icon">{msg.error.invalidData.header}</h1>
    <div className="error-page">
      <p>{msg.error.invalidData.title} {msg.error.invalidData.description}</p>
      <p>
        <a href="/" title={msg.error.error.linkTitle} className="link">
          {msg.error.error.tryAgain}
        </a> {msg.error.error.callUs}
        <a href={`tel:${msg.error.error.callUsNum}`} className="telephone">{msg.error.error.callUsNum}</a>
      </p>
    </div>
  </div>
);
